/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Year_PublishedInputs */

const en_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year Published`)
};

const es_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Año de publicación`)
};

const fr_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Année de publication`)
};

const de_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erscheinungsjahr`)
};

const ja_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発行/公開年`)
};

const zh_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出版年份`)
};

const ar_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنة النشر`)
};

const id_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahun Terbit`)
};

const it_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anno di Pubblicazione`)
};

const ru_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Год выпуска/публикации`)
};

const pt_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano de Publicação`)
};

const ko_field_year_published = /** @type {(inputs: Field_Year_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출판/발행 연도`)
};

/**
* | output |
* | --- |
* | "Year Published" |
*
* @param {Field_Year_PublishedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_year_published = /** @type {((inputs?: Field_Year_PublishedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Year_PublishedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_year_published(inputs)
	if (locale === "es") return es_field_year_published(inputs)
	if (locale === "fr") return fr_field_year_published(inputs)
	if (locale === "de") return de_field_year_published(inputs)
	if (locale === "ja") return ja_field_year_published(inputs)
	if (locale === "zh") return zh_field_year_published(inputs)
	if (locale === "ar") return ar_field_year_published(inputs)
	if (locale === "id") return id_field_year_published(inputs)
	if (locale === "it") return it_field_year_published(inputs)
	if (locale === "ru") return ru_field_year_published(inputs)
	if (locale === "pt") return pt_field_year_published(inputs)
	return ko_field_year_published(inputs)
});